import SmoothScroll from "smooth-scroll";

const scroll = () => new SmoothScroll("[data-scroll]", {
  header: ".header",
  speed: 1000,
});

export default scroll;
